import type { IArticleConfig } from '~/config/article';
import widgetsConfig from '~/config/widgets.config';

// Typescript typings

/** Create a windowed Modal (with window.open) */
class ModalWindow {
  private windowUrl: string;
  public currentWindow: Window | null;
  public windowName: string = 'modal-window';
  private loaded: boolean = false;
  private onLoadCallbacks: Set<(iframeWindow: any) => void> = new Set();
  private configuration;

  constructor(readonly config: IArticleConfig) {
    const modalUrl = widgetsConfig.urls.modal;
    this.configuration = {
      amp: config.amp,
      sdk: config.sdk,
      apiKey: config.apiKey,
      host: config.host,
      url: config.url,
      img: config.img,
      title: config.title,
      articleId: config.articleId,

      globalLang: config.language,
      lang: config.comments && config.comments.transliteration.language,

      font: config.theme && config.theme.font,
      link: config.link,

      anonymous: config.comments && config.comments.auth && config.comments.auth.anonymous,
      version: widgetsConfig.versions.modal,
    };

    this.windowUrl = `${modalUrl}?version=${this.configuration.version}`;
    this.onLoad((modalWindow) => modalWindow.postMessage({ configuration: this.configuration }, '*'));
  }

  /** Open modal in a window */
  public openModalInWindow() {
    const windowInstance = window.open(
      this.windowUrl,
      this.windowName,
      'status = 1, height = 540, width = 600, resizable = 0, top=200, left=400, screenX=400, screenY=200'
    );
    this.currentWindow = windowInstance;
    if (windowInstance) {
      const windowInterval = window.setInterval(() => {
        if (windowInstance && windowInstance.closed) {
          window.clearInterval(windowInterval);
          this.currentWindow = null;
          this.loaded = false;
          windowInstance.close();
        }
      }, 1000);
    }
  }

  public closeWindow() {
    this.currentWindow?.close();
    this.currentWindow = null;
    this.loaded = false;
  }

  /**
   * Add callback to queue to call once widget is loaded after it has been added to the DOM.
   * @param {Function} cb - callback function which should be fired on window load
   * @returns {void}
   */
  public onLoad = (cb: (modalWindow: any) => void): void => {
    if (typeof cb !== 'function') {
      return;
    }
    // ⬇ Call callback instantly if window is already loaded
    if (this.loaded && this.currentWindow) {
      return cb(this.currentWindow);
    }
    // ⬇ Add callback to queue
    if (typeof cb === 'function') {
      this.onLoadCallbacks.add(cb);
    }
  };

  public executeAllCallbacks = () => {
    this.loaded = true;
    // this.onLoad((modalWindow) => modalWindow.postMessage({ configuration: this.configuration }, this.windowUrl));
    this.onLoadCallbacks.forEach((cb) => {
      if (this.currentWindow) {
        cb(this.currentWindow);
      }
    });
    this.onLoadCallbacks.clear();
  };
}

export default ModalWindow;
